var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#27A7E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.973 13.498a1.2 1.2 0 0 0 .186 1.807l3.642 2.542c.51.312 1.194.15 1.32-.525l1.185-9.507c.186-.828-.61-.947-1.098-.702L5.229 11.75c-.728.324-.724.775-.133.976l1.644.57a2.4 2.4 0 0 0 2.073-.242l5.255-3.34c.3-.201.574-.093.349.13",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.b68cda7edae6ca6810f5589e53f6418c.svg";
export { ForwardRef as ReactComponent };